/* eslint-disable max-len */
import 'react';

const ArrowDownFillSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" fill="currentColor" {...props} >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) translate(4.800000, 4.800000)" fillRule="nonzero">
                <rect fill="currentColor" opacity="0" x="0" y="0" width="14.4" height="14.4"></rect>
                <path d="M2.20480009,2.4 L12.3091398,2.4 C12.8683158,2.4 13.3205436,2.84873096 13.3205436,3.40793582 C13.3205436,3.66788117 13.2207617,3.90301775 13.0605839,4.08114019 L8.06375892,10.7485285 C7.72892673,11.1900931 7.09849017,11.2828095 6.653328,10.9479773 C6.57498751,10.8909919 6.50729581,10.8231995 6.45387922,10.7484278 L1.39983866,4.00998044 C1.06870477,3.56831509 1.15772281,2.93448242 1.60285622,2.60314707 C1.78457621,2.46419488 1.99470255,2.40010074 2.20480009,2.40010074 L2.20480009,2.40010074 L2.20480009,2.4 Z" fill="currentColor"></path>
            </g>
        </g>
    </svg>
);
export default ArrowDownFillSvg;
